import { Routes, Route, Navigate } from "react-router-dom";
import { LoginPage } from "./pages/auth/LoginPage";
import { OtpPage } from "./pages/auth/OtpPage";
import { LockedPage } from "./pages/auth/LockedPage";
import { ForcePasswordPage } from "./pages/auth/ForcePasswordPage";
import { AuthGuard } from "./auth/AuthGuard";
import { DashboardLayout } from "./pages/dashboard/DashboardLayout";
import { ExploreArticlesPage } from "./pages/dashboard/articles/ExploreArticlesPage";
import { CreateArticlePage } from "./pages/dashboard/articles/CreateArticlePage";
import { EditArticlePage } from "./pages/dashboard/articles/EditArticlePage";
import { LegalPagesPage } from "./pages/dashboard/legal-pages/LegalPagesPage";
import { FAQPage } from "./pages/dashboard/faqs/FAQPage";
import { UsersPage } from "./pages/dashboard/users/UsersPage";
import { HiyaDecodePage } from "./pages/dashboard/decode/HiyaDecodePage";
import { OrdersPage } from "./pages/dashboard/orders/OrdersPage";
import { SamplesAtLabPage } from "./pages/dashboard/orders/SamplesAtLabPage";
import { ResultsReceivedPage } from "./pages/dashboard/orders/ResultsReceivedPage";
import { ReportsPublishedPage } from "./pages/dashboard/orders/ReportsPublishedPage";
import { NotificationsPage } from "./pages/dashboard/notifications/NotificationsPage";
import { PushNotificationsPage } from "./pages/dashboard/push-notifications/PushNotificationsPage";

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/login/otp" element={<OtpPage />} />
      <Route path="/login/locked" element={<LockedPage />} />
      <Route path="/login/new-password" element={<ForcePasswordPage />} />
      <Route
        path="/dashboard/*"
        element={
          <AuthGuard>
            <DashboardLayout />
          </AuthGuard>
        }
      >
        <Route index element={<Navigate to="orders" replace />} />
        <Route path="orders" element={<OrdersPage />} />
        <Route path="samples" element={<SamplesAtLabPage />} />
        <Route path="results" element={<ResultsReceivedPage />} />
        <Route path="reports-published" element={<ReportsPublishedPage />} />
        <Route path="content/articles" element={<ExploreArticlesPage />} />
        <Route path="content/articles/create" element={<CreateArticlePage />} />
        <Route path="content/articles/:id/edit" element={<EditArticlePage />} />
        <Route path="content/faqs" element={<FAQPage />} />
        <Route path="content/legal-pages" element={<LegalPagesPage />} />
        <Route path="content/decode" element={<HiyaDecodePage />} />
        <Route path="users" element={<UsersPage />} />
        <Route path="notifications" element={<NotificationsPage />} />
        <Route path="push-notifications" element={<PushNotificationsPage />} />
        <Route path="*" element={<Navigate to="orders" replace />} />
      </Route>
      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  );
}
